import React from "react";
import CMSRender from "aldoo-ra/CMS/cms-render";
import parse from "html-react-parser";
import Typography from "aldoo-ra/Typography";

const PricingHeaderBanner = () => {
  return (
    <CMSRender
      contentType="HeaderOfferBanner"
      match={{ "content.name": "PricingHeaderBanner" }}
      renderItem={(data, id) => {
        return (
          <div
            key={id}
            className="w-full flex items-center justify-center pt-[94px] pb-[62px]"
          >
            <div className="relative max-w-[1230px] flex flex-col items-center justify-center mx-auto">
              {/* Title */}
              <Typography
                component="h1"
                variant="h2"
                className="text-text text-center lg:text-left mb-[20px] z-10"
              >
                {data.title && typeof data.title === "string"
                  ? parse(data.title)
                  : data.title}
              </Typography>

              {/* Description */}
              <div className="height-[26px] flex flex-row items-center justify-center gap-[6px] z-10">
                <img
                  src={data.icon}
                  alt="Guarantee"
                  className="w-[26px] h-[26px] object-contain"
                />
                <Typography variant="body1" className="my-0">
                  {data.description}
                </Typography>
              </div>

              {/* Blurred circle background on the left */}
              <div
                className="absolute -left-[80px] -top-12 h-[120px] w-[120px] rounded-full bg-orange_primary opacity-50"
                style={{
                  filter: "blur(50px)",
                }}
              />
            </div>
          </div>
        )
      }}
    />
  );
};

export default PricingHeaderBanner;
